<ul>
  @for (item of (lines()); track item.id) {
  <li>
    <app-product-card [product]="item"></app-product-card>
  </li>
  } @empty {
  @if(leaveEmpty()){}
  @else {
  <li>
    nothing here
  </li>
  }
  }
</ul>
@if(loading()) {
<app-svg use="loading"></app-svg>
}
